module.exports = __webpack_public_path__ + "img/dragAndDrop.8526f4fe.svg";